module.exports = __webpack_public_path__ + "img/hands.d832bfa9.svg";